import { CandidateServicePath, CANDIDATE_STATES } from "utils/constants";

export const resources = {
  name: CandidateServicePath + CANDIDATE_STATES,
  recordRepresentation: "displayTextBg",
};
